import React, { useState, useEffect, useCallback, useContext } from 'react'

import { Link } from 'react-router-dom'
import { connect, useDispatch } from "react-redux";
import { useParams, useLocation } from 'react-router-dom';

import * as actions from "../../../actions/blog";
import * as user from "../../../actions/user";
import * as feedback from "../../../actions/feedback";
import _ from 'lodash'
import { AuthContext } from '../../../context/AuthContext';

import { useHistory } from "react-router-dom"

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import "react-datepicker/dist/react-datepicker.css";
import API from '../../../utils/api';
import Swal from 'sweetalert2';
import { RWebShare } from "react-web-share";
import { IoShareSocialOutline, IoChevronBackOutline, IoChevronForwardOutline, IoCaretDownCircleOutline } from 'react-icons/io5';
import Cookies from 'js-cookie'
import {Helmet} from "react-helmet";


const timeSlots = [
    { name: '9.00 AM', value: '9.00', disabled: false },
    { name: '9.30 AM', value: '9.30', disabled: false },
    { name: '10.00 AM', value: '10.00', disabled: false },
    { name: '10.30 AM', value: '10.30', disabled: false },
    { name: '11.00 AM', value: '11.00', disabled: false },
    { name: '11.30 AM', value: '11.30', disabled: false },
    { name: '12.00 PM', value: '12.00', disabled: false },
    { name: '12.30 PM', value: '12.30', disabled: false },
    { name: '1.00 PM', value: '13.00', disabled: false },
    { name: '1.30 PM', value: '13.30', disabled: false },
    { name: '2.00 PM', value: '14.00', disabled: false },
    { name: '2.30 PM', value: '14.30', disabled: false },
    { name: '3.00 PM', value: '15.00', disabled: false },
    { name: '3.30 PM', value: '15.30', disabled: false },
    { name: '4.00 PM', value: '16.00', disabled: false },
    { name: '4.30 PM', value: '16.30', disabled: false },
    { name: '5.00 PM', value: '17.00', disabled: false },
    { name: '5.30 PM', value: '17.30', disabled: false },
    { name: '6.00 PM', value: '18.00', disabled: false },
    { name: '6.30 PM', value: '18.30', disabled: false },
    { name: '7.00 PM', value: '19.00', disabled: false },
    { name: '7.30 PM', value: '19.30', disabled: false },
    { name: '8.00 PM', value: '20.00', disabled: false },
    { name: '8.30 PM', value: '20.30', disabled: false },
    { name: '9.00 PM', value: '21.00', disabled: false },
    { name: '9.30 PM', value: '21.30', disabled: false }
]

const BlogDetails = (props) => {
    const location = useLocation();
    const { t, i18n } = useTranslation();
    const { getAuthUser, isAuthenticated, getCurrentBranch } = useContext(AuthContext)
    const authUser = getAuthUser()
    const isAuthentic = isAuthenticated()
    // const branch = getCurrentBranch()
    // const [count, setCount] = useState(1)
    const history = useHistory()
    const [service, setService] = useState({})
    const [productCount, setProductCount] = useState(0)
    const [myCart, setMycart] = useState([]);
    const [showReviewModal, setShowReviewModal] = useState(false);
    const [rating, setRating] = React.useState(0);
    const [reviewDesc, setReviewDesc] = React.useState("");
    const [byrating, setByrating] = React.useState({
        5: 0,
        4: 0,
        3: 0,
        2: 0,
        1: 0
    });

    const [totalcount, setTotalcount] = React.useState(0);
    const [averageRating, setAverageRating] = React.useState(0);

    const [slots, setSlots] = useState(timeSlots);
    const [selectedSlot, setSelectedSlot] = useState("");
    const [show, setShow] = useState(false);
    const [selected, setSelected] = useState(new Date());
    const [currentService, setCurrentService] = useState({});
    const [stylePath, setStylePath] = useState(Cookies.get('fj_lang') === 'ar' ? "/assets/css/bootstrap.rtl.min.css" : "/assets/css/bootstrap.min.css");

 

    useEffect(() => {
        const onSuccess = (data) => {

            setService(data)
           
        }
        if (location?.state?.service) {
            console.log(location?.state?.service);
            setService(location.state.service)
            props.fetchById(location?.state?.service?.id, onSuccess)
        } else {

            let params = new URLSearchParams(location.search);
            let gid = params.get('gid');
            let uid = params.get('uid');
            let language = location.pathname.split("/").pop();
            let title =location.pathname.split("/")[2].replaceAll("-"," ")
              console.log('title111',title)
            //start change language

            if(Cookies.get('fj_lang') != language){
                if (language === 'en') {
                    setStylePath("/assets/css/bootstrap.min.css")
                } else {
                    setStylePath("/assets/css/bootstrap.rtl.min.css")
                }
          
                Cookies.set('fj_lang', language)
                i18n.changeLanguage(language);
                window.location.reload(false);

            }
           
            //end change language
            API.blog().getByTitle(title)
            .then(res => {
          
              setService(res.data)
            })
            .catch(err => console.log(err))
          //  props.fetchById(uid, onSuccess)
        }


        setProductCount(props.count)
        setMycart(props.cartArray)

        if (isAuthentic) {
            props.fetchCart(authUser.id)
        }
      
    }, [location?.state?.service])

    return (
        
        <>
         <Helmet>
         <link hrefLang="en-ae" href={process.env.REACT_APP_URL+'blog-details/'+(service?.name?.en)?.replaceAll(' ', '-')?.toLowerCase()+'/en'} rel="alternate"></link>
                <link  hrefLang="ar-ae" href={process.env.REACT_APP_URL+'blog-details/'+(service?.name?.en)?.replaceAll(' ', '-')?.toLowerCase()+'/ar'} rel="alternate"></link>
                <h1>{service?.seoh1?.en && service?.seoh1[i18n.language]}</h1>
                <title>{service?.seotitle?.en && service?.seotitle[i18n.language]}</title>
                <meta name="description" content={service?.seometa?.en && service?.seometa[i18n.language]} />
               
            </Helmet>
         {service?.id?   <section id="product_single_one" className="ptb-100 pt-5">
                <div className="container">
                    <div className="row area_boxed">
                        <div className="col-lg-12 col-12">

                            <ol className="breadcrumb small font-weight-light text-warn bg-white p-0">
                                <li className="breadcrumb-item"><Link to={{ pathname: `/` }}>{t('home')}</Link></li>
                                <li className="breadcrumb-item"><Link to={{ pathname: `/blogs` }}>{t('blogs')}</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">{service?.name?.en && service?.name[i18n.language]}</li>
                            </ol>
                        </div>
                        <div className="col-lg-12 col-12 mb-3">
                            <div className="product_details_right_one">
                                <div className="modal_product_content_one">
                                    <h3 className='font-weight-light text-uppercase'>{service?.name?.en && service?.name[i18n.language]}</h3>
                                    {service?.categoryId?.title?.en && <small className='text-warn my-3'><span className='text-uppercase text-warn mr-2'>{service?.categoryId?.title[i18n.language]}</span> <span className='text-black-50'>{moment(service.createdDate).format("ll")}</span></small>}

                                    <div className='float-right'>
                                        <RWebShare
                                            data={{
                                                text: service?.description?.en?.slice(0, 55) + '...',
                                                url: `https://aecmc.com/blog-details/${(service?.name?.en).replaceAll(' ', '-').toLowerCase()}/${i18n.language}`,
                                                title: service?.title?.en,
                                            }}
                                            onClick={() => console.log("shared successfully!")}
                                        >
                                            <a className="action quickview text-warn float-right" ><IoShareSocialOutline size={20} /></a>
                                        </RWebShare>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 col-12">
                            <div className="product_single_one_img">
                                <img className="d-block w-50 float-left mr-3" src={process.env.REACT_APP_IMG_URL + service.image} />

                                <div className="product_description">
                                    {service.about?.en && <div className='htmparser'>{parse(service.about[i18n.language])}</div>}

                                </div>
                            </div>
                        </div>

                    </div>


                </div>
            </section>: <>
 <div className='py-5 text-center'>
 <div className="spinner-border text-secondary" role="status">
<span className="sr-only">Loading...</span>
</div>
 </div>
 
 </> }
        </>
    )
}

const mapStateToProps = state => ({

    users: state.user.users,
    cart: state.user.cart,
    cartArray: state.user.cartArray,
    currentService: state.service.currentService,
    feedbacks: state.feedback.feedbacks,
    feedbacksMeta: state.feedback.meta
})

const mapActionToProps = {
    update: actions.update,
    fetchById: actions.fetchById,
    updateUser: user.update,
    updateUserCart: user.updateCart,
    fetchCart: user.fetchCart,
    addReview: feedback.create,
    fetchRating: feedback.fetchAll,
    getByServiceId: feedback.getByServiceId
}

export default connect(mapStateToProps, mapActionToProps)(BlogDetails);